import { action, runInAction, computed } from "mobx";
import { ApiResult, FieldType, ViewModelBase, observable } from "@shoothill/core";
import { InductionAdminNonConformanceAndRelatedDTO, InductionAdminNonConformanceListModel } from "./InductionAdminNonConformanceListModel";
import { AppUrls } from "AppUrls";

export class InductionAdminNonConformanceViewModel extends ViewModelBase<any> {
    public projectId: string = "";
    @observable public nonConformanceListModels: InductionAdminNonConformanceListModel[] = [];
    constructor(inductionUserId: string) {
        super();
        this.loadNonConformanceAndRelated(inductionUserId);
    }

    @computed
    public get nonConformanceListItems() {
        const list = this.nonConformanceListModels.sort((a: any, b: any) => b.nonConformanceNumber - a.nonConformanceNumber);
        return list;
    }

    public loadNonConformanceAndRelated = async (id: string): Promise<ApiResult<InductionAdminNonConformanceAndRelatedDTO>> => {
        this.setIsLoading(true);
        let params = { id: id };

        const apiResult = await this.Post<InductionAdminNonConformanceAndRelatedDTO>(AppUrls.Server.Induction.GetInductionNonConformanceByInductionUserId, params);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.nonConformanceListModels = [];
                    for (const nonConformance of apiResult.payload.nonConformanceListItems) {
                        let model = new InductionAdminNonConformanceListModel();
                        model.fromDto(nonConformance);
                        this.nonConformanceListModels.push(model);
                    }
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
        return apiResult;
    };

    @action
    public handleRowClick = (e: any, rowData: InductionAdminNonConformanceListModel) => {
        if (rowData.nonConformanceTypeName === "Housekeeping") {
            this.history.push(AppUrls.Client.Project.NonConformance.HouseKeeping.View.replace(":projectid", rowData.projectId).replace(":nonConformanceId", rowData.id!));
        } else if (rowData.nonConformanceTypeName === "Discipline") {
            this.history.push(AppUrls.Client.Project.NonConformance.Discipline.View.replace(":projectid", rowData.projectId).replace(":nonConformanceId", rowData.id!));
        } else if (rowData.nonConformanceTypeName === "Quality") {
            this.history.push(AppUrls.Client.Project.NonConformance.Quality.View.replace(":projectid", rowData.projectId).replace(":nonConformanceId", rowData.id!));
        } else if (rowData.nonConformanceTypeName === "Environment") {
            this.history.push(AppUrls.Client.Project.NonConformance.Environment.View.replace(":projectid", rowData.projectId).replace(":nonConformanceId", rowData.id!));
        } else {
            this.history.push(AppUrls.Client.Project.NonConformance.View.replace(":projectid", rowData.projectId).replace(":nonConformanceId", rowData.id!));
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<any>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
